import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

export default function CategoryEntries() {
  const counts = categories.map((cat) => ({
    ...cat,
    count: articles.filter((item) => item.category === cat.slug).length,
  }));

  return (
    <section className="mx-auto max-w-[1200px] px-4 py-14 md:px-8 md:py-16">
      <div className="mb-8 flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">Categories</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">分类快捷入口</h2>
        </div>
        <Link
          to="/categories"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
        >
          查看全部内容 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {counts.map((cat) => (
          <Link
            key={cat.slug}
            to={`/categories?cat=${cat.slug}`}
            className="group relative h-64 overflow-hidden rounded-lg"
          >
            <img
              src={cat.cover}
              alt={`${cat.name}分类`}
              title={`${cat.name} - 黑丝时尚分类`}
              className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-5">
              <span className="inline-flex rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                {cat.count} 篇内容
              </span>
              <h3 className="mt-3 font-heading text-xl font-bold text-background-50">{cat.name}</h3>
              <p className="mt-1 line-clamp-2 text-sm text-background-100/85">{cat.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}